<template>
  <div class="priority-select" v-if="healthMode">
    <v-select
      class="form-input"
      :value="healthMode"
      @change="onAppQuestionChange"
      :items="questions"
      placeholder="Select App Questions"
      item-value="code"
      item-text="body"
      hide-details
    />
  </div>
</template>

<script>

export default {
  name: 'PlateHealthPriority',
  data() {
    return {
      healthMode: null,
      questions: [
        {
          code: 'prosperity_life',
          body: "Prosperity App Q's",
          order: 'primary',
        },
        {
          code: 'liberty_bankers',
          body: "Liberty Banker's App Q's",
          order: 'secondary',
        },
      ],
    };
  },

  mounted() {
    this.healthMode = this.$store.getters['plates/appQuestion'];
  },
  methods: {
    onAppQuestionChange(val) {
      this.$store.commit('plates/setAppQuestion', val);
    },
  },
};
</script>

<style scoped>
.priority-select {
  max-width: 250px;
  margin-left: 30px;
}
</style>